import React from 'react'
import PropTypes from 'prop-types'

import { Card } from 'semantic-ui-react'

const ReservationSection = ({ children, title }) => (
  <Card.Content extra>
    <Card.Header>{title}</Card.Header>

    {children}
  </Card.Content>
)

ReservationSection.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
}

export default ReservationSection
